import SystemFooter from '@/components/_common/SystemFooter';

const ApplicationFooter = () => <SystemFooter />;

export default ApplicationFooter;
